import ReactDOM from 'react-dom';
import { useOutside } from "hooks/UseOutside";
import { Dispatch, SetStateAction, useRef, useState } from "react";

import SuccessPentagon from '../../../../assets/img/success-pentagon.png';

import { ModalButton, ModalCloseButton, ModalContainer, ModalImage, ModalSection, ModalSubtitle, ModalTitle } from './_documentsMissingModal';

interface IDocumentsMissingModalProps {
  toggleModal: Dispatch<SetStateAction<boolean>>;
  callback?: () => void;
}

export const DocumentsMissingModal = ({
  toggleModal
}: IDocumentsMissingModalProps) => {
  const modalRoot = document.getElementById('root-modal');
  const modalRef = useRef(null);

  const [hideModal, setHideModal] = useState(false);

  const handleCloseModal = () => {
    setHideModal((prevState) => !prevState);

    setTimeout(() => {
      toggleModal((prevState) => !prevState);

      localStorage.setItem('@RepfyProvider: DocumentsApproved', 'viewed')
    }, 500);
  }

  useOutside(modalRef, handleCloseModal);

  if(!modalRoot) {
    return null;
  }

  return ReactDOM.createPortal(
    <ModalSection className={`${hideModal ? 'modal-approved-docs--hide' : ''}`}>
      <ModalContainer ref={modalRef}>
        <ModalCloseButton
          type="button"
          onClick={handleCloseModal}
        >
          X
        </ ModalCloseButton>
        <ModalTitle>
          Aguarde a aprovação
        </ModalTitle>
        <ModalSubtitle>
          Ação permitida após a
         aprovação da documentação
        </ModalSubtitle>
        <ModalImage src={SuccessPentagon} alt="documents submitted" />
        <ModalButton type="button" onClick={handleCloseModal}>
          ok, vamos lá!
        </ModalButton>
      </ModalContainer>
     </ModalSection>
    ,modalRoot
  )
}
